import { render, staticRenderFns } from "./uploadList.vue?vue&type=template&id=72980e37"
import script from "./uploadList.vue?vue&type=script&lang=js"
export * from "./uploadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports